import { render, staticRenderFns } from "./UrunKampanyalar.vue?vue&type=template&id=57e10b88&scoped=true"
import script from "./UrunKampanyalar.vue?vue&type=script&lang=js"
export * from "./UrunKampanyalar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e10b88",
  null
  
)

export default component.exports